import React from "react";
import { useTranslation } from "react-i18next";

import HeroStyle2 from "../Hero/HeroStyle2";
import AboutSection from "../Section/AboutSection";
import BannerSectionStyle8 from "../Section/BannerSection/BannerSectionStyle8";
import Section from "../Section";
import FeaturesSection from "../Section/FeaturesSection";
import ContactForm from "../ContactForm"; // renamed AppointmentForm -> ContactForm

import DepartmentSection from "../Section/DepartmentSection"; // now Services section
import { pageTitle } from "../../helpers/PageTitle";
import BrandsSectionStyle2 from "../Section/BrandsSection/BrandsSectionStyle2";
import SEO from '../SEO';

export default function Home() {
  const { t } = useTranslation();
  pageTitle(t("home.pageTitle"));

  // VALUES (featureListData)
  const featureListData = [
    {
      iconSrc: "/images/home_1/compassion.svg",
      title: t("home.valueIntegrityTitle"),
      subTitle: t("home.valueIntegrityDesc"),
    },
    {
      iconSrc: "/images/home_1/excellence.svg",
      title: t("home.valueExcellenceTitle"),
      subTitle: t("home.valueExcellenceDesc"),
    },
    {
      iconSrc: "/images/home_1/integrity.svg",
      title: t("home.valueRespectTitle"),
      subTitle: t("home.valueRespectDesc"),
    },
    {
      iconSrc: "/images/home_1/respect.svg",
      title: t("home.valueReliabilityTitle"),
      subTitle: t("home.valueReliabilityDesc"),
    },
  ];

  // SERVICES SECTION (old DepartmentSection)
  const servicesData = [

    {
      title: t("home.service2Title"),
      subTitle: t("home.service2Description"),
      iconUrl: "images/departments/icon_2.svg",
      href: "/services/import-export",
    },
    {
      title: t("home.service3Title"),
      subTitle: t("home.service3Description"),
      iconUrl: "images/departments/icon_3.svg",
      href: "/services/regulatory",
    },
    {
      title: t("home.service4Title"),
      subTitle: t("home.service4Description"),
      iconUrl: "images/departments/icon_4.svg",
      href: "/services/marketing",
    },
    {
      title: t("home.service5Title"),
      subTitle: t("home.service5Description"),
      iconUrl: "images/departments/icon_5.svg",
      href: "/services/storage",
    },
    {
      title: t("home.service6Title"),
      subTitle: t("home.service6Description"),
      iconUrl: "images/departments/icon_6.svg",
      href: "/services/medical-devices",
    },
  ];
  
  // PARTNERS
  const brandData = [
    { imgUrl: "images/partners/partner_3.svg", imgAlt: "Partner" },
    { imgUrl: "images/partners/partner_4.svg", imgAlt: "Partner" },
    { imgUrl: "images/partners/partner_11.png", imgAlt: "Partner" },
    { imgUrl: "images/partners/vantive.svg", imgAlt: "Partner" },
    { imgUrl: "images/partners/partner_17.png", imgAlt: "Partner" },
    { imgUrl: "images/partners/partner_25.png", imgAlt: "Partner" },
  ];

  return (
    <>
      <SEO title="Incomed - Zgjedhje e Besueshme në Distribucion Farmaceutik" description="Shpërndarës i autorizuar i produkteve farmaceutike dhe medicinale në Shqipëri. Partneri juaj i besueshëm në shëndetësi." url="/" />
      {/* HERO */}
      <HeroStyle2
        title={t("home.heroTitle")}
        subTitle={t("home.heroSubtitle")}
        bgUrl="/images/banner.png"
        bgOverlay="/images/home_1/hero_bg.jpeg"
        imgUrl="/images/home_2/patents.png"
        videoBtnText={t("home.heroVideoText")}
        videoUrl="https://www.youtube.com/embed/VcaAVWtP48A"
        btnText="Incomed"
        btnUrl="/"
        funfactList={[
          { number: "20+", title: t("home.funfact1") },
          { number: "2000+", title: t("home.funfact2") },
          { number: "15+", title: t("home.funfact3") },
          { number: "3", title: t("home.funfact4") },
        ]}
      />

      {/* VALUES */}
      <Section
        topMd={150}
        topLg={120}
        topXl={100}
        bottomMd={150}
        bottomLg={120}
        bottomXl={100}
      >
        <FeaturesSection
          sectionTitle={t("home.valuesTitle")}
          data={featureListData}
        />
      </Section>

      {/* ABOUT */}
      <Section>
        <AboutSection
          imgUrl="/images/about/magazine.jpg"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title={t("home.aboutTitle")}
          subTitle="Incomed"
          featureList={[
            {
              featureListTitle: t("home.aboutText1"),
              featureListSubTitle: t("home.aboutText2"),
            },
          ]}
        />
      </Section>

      {/* SERVICES SECTION */}
      <Section topMd={150} topLg={120} topXl={100}>
        <DepartmentSection
          sectionTitle={t("home.servicesTitle")}
          bgUrl="images/home_1/department_bg.svg"
          data={servicesData}
        />
      </Section>

      {/* BANNER CTA */}
      <Section
        bottomMd={80}
        bottomLg={60}
        bottomXl={40}
        style={{background: "linear-gradient(180deg, #ffffff 0%, #ddeaf8 100%)"}}
      >
        <BannerSectionStyle8
          bgUrl="images/home_3/banner_bg.svg"
          imgUrl="images/banner/banner_2.png"
          title={t("home.ctaTitle")}
          subTitle={t("home.ctaSubtitle")}
        />
      </Section>

      {/* PARTNERS */}
      <Section
        topMd={80}
        topLg={60}
        topXl={40}
        bottomMd={100}
        bottomLg={80}
        bottomXl={60}
        style={{background: "linear-gradient(180deg, #ddeaf8 0%, #ffffff 100%)"}}
      >
        <BrandsSectionStyle2 data={brandData} sectionTitle={t("home.partnersTitle")} />
      </Section>

      {/* CONTACT SECTION */}
      <Section topMd={150} topLg={120} topXl={100} id="contact" style={{marginBottom: 40}}>
        <h2 className="text-center mb-5">{t("home.contactTitle")}</h2>
        <ContactForm />
      </Section>

      {/* PARTNERS */}
    
    </>
  );
}
